import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Returns a function that can be used to form up org-relative app paths.
 * Pass an empty string for the org home path.
 *
 * @example
 *
 * const createOrgUrl = useCreateOrgUrl();
 * const url = createOrgUrl('/path/to/page'); // Will return '/some-org/path/to/page'
 */
export function useCreateOrgUrl() {
  const { orgName, region } = useParams();
  return useCallback((subPath: string) => `/${region}/${orgName}${subPath}`, [orgName, region]);
}
